<script setup lang="ts">

import mapboxgl from "mapbox-gl";
import {ref} from "vue";
import {ILocation} from "@/models/Location";
import { useI18n } from 'vue-i18n';

const map = ref<mapboxgl.Map | null>(null);
const { t } = useI18n();
mapboxgl.accessToken = import.meta.env.VITE_MAPBOX_API_KEY;

const model = defineModel<ILocation>()

const props = defineProps({
  class: {
    type: String,
    default: '',
  },
  state: {
    type: String <'enabled'|'disabled'>,
    default: 'enabled'
  }
});



function showMapPopup() {
  if (!model.value || !model.value.name) {
    console.warn("Missing location name.", model.value);
    return;
  }
  
  const lat = model.value.lat || model.value.latitude;
  const lng = model.value.lng || model.value.longitude;

  if (!lat || !lng) {
    return;
  }
  
  const mapOverlay = document.getElementById("map-overlay");
  if (mapOverlay) mapOverlay.classList.remove("hidden");

  if (!map.value) {
    map.value = new mapboxgl.Map({
      container: "map-overlay-map",
      style: "mapbox://styles/mapbox/streets-v11",
      center: [lng, lat],
      zoom: 12,
    });
  } else {

    map.value.setCenter([lng, lat]);
  }

  /// Remove any existing popups
  document.querySelectorAll(".mapboxgl-popup").forEach(popup => popup.remove());

  // Create a new popup with location info
  new mapboxgl.Popup()
      .setLngLat([lng, lat])
      .setHTML(`<div class="flex items-center">
        <img src="../../assets/ancor.png" alt="Anchor" class="w-3 h-3 mr-1">
        <h3>${model.value.name}</h3>
        </div>`)
      .addTo(map.value);
}
</script>
<template>
  <div
      :class="'cursor-pointer hover:opacity-60 transition-opacity flex items-center gap-2 ' + props.class"
      @click="showMapPopup"
  >
    <img src="../../assets/icons/svg/Location_16x16.svg" alt="location" class="h-4 w-4" />
    <div class="responsive-caption uppercase">{{ model?.name }}</div>
  </div>
</template>

